/* =========================================================
   portfolio.js (CLEAN + COMPATIBLE WITH YOUR CURRENT LIQUID)
   - Scroll reveal (optional)
   - Marquee:
     * Mobile: manual scroll only (no animation)
     * Desktop: seamless loop using your 2-group Liquid output
       - sets --rr-marquee-distance to width of first group
       - sets animation duration from data-speed OR CSS var fallback
   ========================================================= */

(function () {
  // ---------- Media queries ----------
  const mqDesktop = () =>
    window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const mqReduced = () =>
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---------- Scroll reveal ----------
  function initReveal() {
    const sections = document.querySelectorAll(".rr-portfolio[data-rr-reveal='true']");
    if (!sections.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
    );

    sections.forEach((sec) => {
      sec.querySelectorAll(".rr-reveal").forEach((el) => io.observe(el));
    });
  }

  // ---------- Marquee: Desktop only ----------
  function initMarquees() {
    const marquees = document.querySelectorAll(".rr-marquee[data-rr-marquee]");
    if (!marquees.length) return;

    const isDesktop = mqDesktop();
    const reduced = mqReduced();

    marquees.forEach((mq) => {
      const loop = mq.querySelector(".rr-marquee__loop");
      const inner = mq.querySelector(".rr-marquee__inner");
      const groups = mq.querySelectorAll(".rr-marquee__group");

      // If any key elements are missing, bail safely
      if (!inner || !groups.length) return;

      // Reduced motion OR not desktop pointer => no animation from JS
      if (reduced || !isDesktop) {
        inner.style.animation = "none";
        inner.style.transform = "none";
        mq.dataset.rrMarqueeInit = "0";
        return;
      }

      // Prevent repeated init
      if (mq.dataset.rrMarqueeInit === "1") return;
      mq.dataset.rrMarqueeInit = "1";

      // Use the first group width as the travel distance (true seamless)
      const groupA = groups[0];

      // Speed: data-speed optional (we'll support it), otherwise use CSS var already set by Liquid
      const speed = parseFloat(mq.getAttribute("data-speed") || "");

      // Measure after layout settles (images can change widths slightly)
      const measureAndApply = () => {
        const dist = groupA.scrollWidth;

        // Set distance on the marquee root so keyframes can read it
        mq.style.setProperty("--rr-marquee-distance", dist + "px");

        // If data-speed exists, translate it to duration.
        // Higher speed => faster (shorter duration).
        // This mapping matches your previous tuning style.
        if (!Number.isNaN(speed)) {
          // px per second target range (tuneable)
          const pxPerSec = Math.max(50, Math.min(180, speed * 4.1));
          const duration = Math.max(8, dist / pxPerSec);
          mq.style.setProperty("--rr-marquee-duration", duration + "s");
        }
      };

      // Run once now, and again after images load (for accuracy)
      measureAndApply();

      // If images load later, re-measure
      const imgs = mq.querySelectorAll("img");
      let pending = 0;

      imgs.forEach((img) => {
        if (img.complete) return;
        pending += 1;
        img.addEventListener(
          "load",
          () => {
            pending -= 1;
            // When most images are in, re-measure
            if (pending <= 0) measureAndApply();
          },
          { once: true }
        );
      });

      // Also re-measure on the next frame (covers font/layout shifts)
      requestAnimationFrame(measureAndApply);
    });
  }

  // ---------- Boot ----------
  document.addEventListener("shopify:section:load", function () {
    initReveal();
    initMarquees();
  });

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initMarquees();
  });

  // Re-evaluate on resize / rotate
  let lastDesktop = mqDesktop();
  window.addEventListener(
    "resize",
    function () {
      const nowDesktop = mqDesktop();
      if (nowDesktop !== lastDesktop) {
        lastDesktop = nowDesktop;
        document.querySelectorAll(".rr-marquee[data-rr-marquee]").forEach((mq) => {
          mq.dataset.rrMarqueeInit = "0";
        });
      }
      initMarquees();
    },
    { passive: true }
  );
})();
